import { gql } from "lib/apolloClient";
import { userCoursesPageFragment } from "./CoursesFragments";

export const getUserCoursesV2Query = gql`
  query getUserCoursesV2(
    $userId: ID!
    $first: Int
    $after: String
    $courseFilters: CourseFilter
    $archivedCourseFilters: CourseFilter
    $courseGradeFilters: CourseGradeFilters
  ) {
    node(id: $userId, type: STAFF) {
      id
      ...staffCourses
      __typename
    }
  }

  ${userCoursesPageFragment}
`;

export const getWorkrampLoginUrlQuery = gql`
  query getWorkrampLoginUrl($id: ID!, $type: ENTITY_TYPE_ENUM!) {
    node(id: $id, type: $type) {
      ... on Staff {
        workrampLoginUrl
      }
    }
  }
`;
